import React, { useEffect } from 'react';
import { usePageTitle } from '../context/PageTitleContext';
import './Support.scss';

function Support() {
  const { setPageTitle } = usePageTitle();
  
  // Set page title when component mounts
  useEffect(() => {
    setPageTitle("Support");
  }, [setPageTitle]);

  return (
    <div className="support-page">
      <h1>Support</h1>
      <p>Get help with your services or create a new support request.</p>
      
      <div className="support-options">
        <div className="card support-card">
          <div className="card-body">
            <h3>Create Support Ticket</h3>
            <p>Need help with something? Submit a support ticket and our team will assist you.</p>
            <button className="btn btn-primary">New Ticket</button>
          </div>
        </div>
        
        <div className="card support-card">
          <div className="card-body">
            <h3>Knowledge Base</h3>
            <p>Find answers to common questions in our knowledge base.</p>
            <button className="btn btn-secondary">Browse Articles</button>
          </div>
        </div>
        
        <div className="card support-card">
          <div className="card-body">
            <h3>Contact Us</h3>
            <p>Reach out to us directly via email or phone.</p>
            <p className="contact-info">info@fredocloud.com</p>
            <p className="contact-info">+1 (555) 123-4567</p>
          </div>
        </div>
      </div>
      
      <div className="card mt-4">
        <div className="card-header">
          <h3>My Support Tickets</h3>
        </div>
        <div className="card-body">
          <div className="empty-state">
            <p>You don&apos;t have any active support tickets.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support; 